import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { FC, useMemo, useState } from "react";
import { DiaryEntry } from "src/apis/diary";
import NoDataAlert from "src/pages/components/NoDataAlert";
import { formatDateToBR } from "src/utils/date";

const ROWS = 10;

type Props = {
  entries: DiaryEntry[];
  onEdit: (item: DiaryEntry) => void;
  onDelete: (id: number) => void;
};

const DiaryEntriesTable: FC<Props> = ({ entries, onEdit, onDelete }): JSX.Element => {
  const hasData = useMemo(() => Boolean(entries) && entries.length > 0, [entries]);
  const [page, setPage] = useState(0);

  if (!hasData) return <NoDataAlert />;

  const pageSlice = entries.slice(page * ROWS, page * ROWS + ROWS);

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Typography fontWeight={600}>Data</Typography></TableCell>
              <TableCell><Typography fontWeight={600}>Empresa</Typography></TableCell>
              <TableCell><Typography fontWeight={600}>Título</Typography></TableCell>
              <TableCell><Typography fontWeight={600}>Mensagem</Typography></TableCell>
              <TableCell><Typography fontWeight={600}>Participantes</Typography></TableCell>
              <TableCell align="right"><Typography fontWeight={600}>Opções</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageSlice.map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>{formatDateToBR(item.data)}</TableCell>
                <TableCell>{item.empresa ?? "-"}</TableCell>
                <TableCell>{item.titulo}</TableCell>
                <TableCell sx={{ maxWidth: 360, whiteSpace: "pre-wrap" }}>
                  {item.mensagem}
                </TableCell>
                <TableCell>{item.numero_participantes ?? "-"}</TableCell>
                <TableCell align="right">
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar">
                      <IconButton size="small" onClick={() => onEdit(item)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton size="small" onClick={() => onDelete(item.id)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={entries.length}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        rowsPerPage={ROWS}
        rowsPerPageOptions={[ROWS]}
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
      />
    </>
  );
};

export default DiaryEntriesTable;
